import config from "config/config.js";

const getSlot = (orgId, date) => {
  const endpoint = `${config.baseUrl}/slot_orarie/listaOnline/${orgId}/${date}`;
  const options = {
    method: "get",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
  return fetch(endpoint, options)
    .then((response) => response.json())
    .then((res) => {
      return res;
    })
    .catch((e) => {
      // eslint-disable-next-line no-console
      // console.log("error: ", e);
      return null;
    });
};

export default getSlot;
